import { Route, Routes } from "react-router-dom";
import "./App.css";
import WhiteBoard from "./components/WhiteBoard";
function App() {
  return (
    <Routes>
      <Route path="/" element={<WhiteBoard />} />
    </Routes>
  );
}

export default App;
